import { useId, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './Icon';
import { useOverlay } from './overlay';

/**
 * The detail drawer (spec §9): slides in from the right over a scrim, full width on phones.
 * Escape, the close button and a click on the scrim call `onClose`. `footer` holds the actions.
 */
export function Drawer({
  open,
  onClose,
  title,
  sub,
  children,
  footer,
  wide,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  sub?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** 820px instead of 560px, for answer viewers and side-by-side comparisons. */
  wide?: boolean;
}) {
  const ref = useOverlay(open, onClose);
  const titleId = useId();
  if (!open) return null;
  return createPortal(
    <>
      <div className="scrim" onClick={onClose} aria-hidden="true" />
      <div ref={ref} className={`drawer${wide ? ' wide' : ''}`} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1}>
        <div className="dh">
          <div className="tt">
            <h2 id={titleId}>{title}</h2>
            {sub ? <div className="sub">{sub}</div> : null}
          </div>
          <button type="button" className="x-btn" onClick={onClose} aria-label="Close">
            <Icon name="close" />
          </button>
        </div>
        <div className="db">{children}</div>
        {footer ? <div className="df">{footer}</div> : null}
      </div>
    </>,
    document.body,
  );
}
